<nav class="navbar navbar-default navbar-fixed-top top-bar-region top-bar primary">
  <div class="container-fluid top-bar-content">
    <ng-content/>
    <p class="navbar-text">{{ title || (settingsObservable | async)?.name }}</p>
  </div>
</nav>
